import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import eventsSlice from '../reducers/events.slice'

const persistConfig = {
  key: 'eventsSlice',
  storage,
}

export const persistedEventsReducer = persistReducer(persistConfig, eventsSlice)